import { Card } from '@/components'
import { TrialPageFrame } from '@/modules/auth'
import { TrialPhoneNotice } from '@/modules/projects'
import { WebsocketProvider } from '@/modules/websocket'
import { CaseNameForm } from './CaseNameForm'
import { FinishingSetup } from './FinishingSetup'
import { LiveCaseForm } from './LiveCaseForm'
import { TrialLiveHeading } from './TrialLiveHeading'
import { TrialRefused } from './TrialRefused'
import { useWaitForTrial } from './useWaitForTrial'

export const TrialWelcomePage = () => (
  <WebsocketProvider>
    <TrialPageFrame>
      <main className="flex flex-1 items-center justify-center">
        <TrialWelcomeCard />
      </main>
    </TrialPageFrame>
  </WebsocketProvider>
)

const TrialWelcomeCard = () => {
  const { isLive, isRefused, isSlow } = useWaitForTrial()

  if (isRefused) {
    return (
      <Card className="w-full max-w-120 p-6 sm:p-10">
        <TrialRefused />
      </Card>
    )
  }

  return (
    <Card
      aria-busy={!isLive}
      className="flex w-full max-w-120 flex-col gap-6 p-6 sm:p-10"
    >
      {isLive ? <TrialLiveHeading /> : <FinishingSetup isSlow={isSlow} />}
      {isLive ? <LiveCaseForm /> : <CaseNameForm isDisabled />}
      {isLive && <TrialPhoneNotice />}
    </Card>
  )
}
